import axios from "axios";
import { API_URL } from "./conection";

// --- Áreas ---

export const getCenters = async (params = {}) => {
  try {
    const res = await axios.get(`${API_URL}/areas`, { params });
    return res.data;
  } catch (error) {
    console.error("Error en getCenters:", error);
    return [];
  }
};

export const getAreaById = async (areaMongoId) => {
  try {
    const res = await axios.get(`${API_URL}/areas/${areaMongoId}`);
    return res.data;
  } catch (error) {
    console.error("Error en getAreaById:", error);
    return null;
  }
};

export const createArea = async (data) => {
  const res = await axios.post(`${API_URL}/areas`, data);
  return res.data;
};

// areaMongoId = _id de MongoDB
export const updateArea = async (areaMongoId, data) => {
  const res = await axios.put(`${API_URL}/areas/${areaMongoId}`, data);
  return res.data;
};

export const deleteArea = async (areaMongoId) => {
  const res = await axios.delete(`${API_URL}/areas/${areaMongoId}`);
  return res.data;
};

// --- Instalaciones (centros dentro de un área) ---

// areaMongoId = _id de MongoDB
export const addCenter = async (areaMongoId, data) => {
  const res = await axios.post(`${API_URL}/areas/${areaMongoId}/centers`, data);
  return res.data;
};

export const updateCenter = async (areaMongoId, centerId, data) => {
  const res = await axios.put(`${API_URL}/areas/${areaMongoId}/centers/${centerId}`, data);
  return res.data;
};

export const deleteCenter = async (areaMongoId, centerId) => {
  const res = await axios.delete(`${API_URL}/areas/${areaMongoId}/centers/${centerId}`);
  return res.data;
};
